import axios from 'axios';
import Vue from 'vue'

export default {
    uploadBanner(formData, regionId) {
        return axios.post("/api/banner/upload/"+regionId, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {

                if (response && response.data) {
                    Vue.prototype.$snotify.success("Banniére ajoutée avec succès");
                    return response.data;
                }
            })
            .catch(error => { Vue.prototype.$snotify.error(error); })
    },

    uploadBannerAds(formData) {
        return axios.post("/api/banner/upload-banner-ads/", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {
                if (response && response.data) {
                    Vue.prototype.$snotify.success("Banniére ajoutée avec succès");
                    return response.data;
                }
            })
            .catch(error => { Vue.prototype.$snotify.error(error); })
    },

    uploadBannerLogin(formData) {
        return axios.post("/api/banner/upload-login/", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {

                if (response && response.data) {
                    Vue.prototype.$snotify.success("Banniére de bienvenue ajoutée avec succès");
                    return response.data;
                }
            })
            .catch(error => { Vue.prototype.$snotify.error(error); })
    },
    
    getBanners (windowWidth) {
        return axios.get('/api/banner/list',{ params: {windowWidth: windowWidth} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getBannersAds (page, pageSize, ignorePagination, isCatalogBannerAds) {
        return axios.get('/api/banner/ads-list',{params: {page: page, pageSize: pageSize, ignorePagination:ignorePagination, isCatalogBannerAds:isCatalogBannerAds} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getBannersLogin () {
        return axios.get('/api/banner/login-list' )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeBanner (bannerId) {
        return axios.post('/api/banner/remove', {id : bannerId})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Bannière supprimé avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    removeBannerAds (bannerAdsId) {
        return axios.post('/api/banner/ads-remove', {id : bannerAdsId})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Bannière supprimé avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    editBannerAds (banner) {
        return axios.post('/api/banner/change-banner-ads', banner)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Bannière modifiée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    savePosition (banner) {
        return axios.post('/api/banner/changePosition', banner)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Bannière modifiée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveLoginBanner (banner) {
        return axios.post('/api/banner/save-login-banner', banner)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Bannière de bienvenue modifiée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    displaySpecialBanner () {
        return axios.get('/api/banner/special')
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(  ()  => { } );
    },
}